var map = {
	"./euro2024.webp": 1505,
	"./euro2024_title.svg": 1506,
	"./event-sport-bg.jpg": 1507,
	"./event-sport-bg.png": 1508,
	"./home-icon-active.webp": 1509,
	"./home-icon.webp": 1510,
	"./img_bg-uefa.png": 1511,
	"./live-icon-active.webp": 1512,
	"./master-bg.webp": 1513,
	"./me-icon-active.webp": 1514,
	"./product-overview-bg.webp": 1515,
	"./promos-icon-active.webp": 1516,
	"./sponsor-icon-active.webp": 1517,
	"./uefa-icon-active.webp": 1518,
	"./uefa-icon.webp": 1519,
	"./uefa-prediction.webp": 1520,
	"./wwr-img.webp": 1521
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 209;